import { Package, Utensils, UserCheck, Truck } from "lucide-react";
import { SERVICE_STYLES } from "../data/content";
import { Reveal } from "./Reveal";

const ICONS = { Package, Utensils, UserCheck, Truck };

export const ServiceStyles = () => {
  return (
    <section data-testid="service-styles-section" className="py-16 sm:py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">
        <div className="max-w-3xl">
          <Reveal>
            <p className="text-[12px] font-bold uppercase tracking-[0.22em] text-brand-teal">
              Service Styles
            </p>
          </Reveal>
          <Reveal delay={1}>
            <h2 className="mt-3 font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight text-brand-charcoal leading-[1.05]">
              Flexible Service for
              <br />
              Any Type of Event.
            </h2>
          </Reveal>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {SERVICE_STYLES.map((s, i) => {
            const Icon = ICONS[s.icon] || Package;
            return (
              <Reveal key={s.title} delay={Math.min(i + 1, 4)}>
                <div
                  data-testid={`service-card-${s.title.toLowerCase().replace(/\s+/g, "-")}`}
                  className="group h-full rounded-3xl bg-brand-cream border border-black/5 p-7 transition-all hover:-translate-y-1 hover:bg-white hover:border-brand-teal/30 hover:shadow-[0_22px_40px_-22px_rgba(17,17,17,0.25)]"
                >
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-charcoal text-white group-hover:bg-brand-teal transition-colors">
                    <Icon className="h-5 w-5" />
                  </span>
                  <h3 className="mt-5 font-display font-bold text-[20px] text-brand-charcoal tracking-tight">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-[14px] text-brand-charcoal/70 leading-relaxed">
                    {s.description}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServiceStyles;
